export function cooldownDeadlineFromError(error, nowValue = Date.now()) {
    const response = error && error.response;
    const data = response && response.data || {};
    const serverDeadline = data.blockedUntil ? new Date(data.blockedUntil).getTime() : NaN;
    if (Number.isFinite(serverDeadline) && serverDeadline > nowValue) return serverDeadline;
    const retryAfterSeconds = Number(data.retryAfterSeconds);
    return nowValue + (Number.isFinite(retryAfterSeconds) && retryAfterSeconds > 0
        ? retryAfterSeconds * 1000
        : 3 * 60 * 1000);
}

export function cooldownSecondsRemaining(deadline, nowValue = Date.now()) {
    return Math.max(0, Math.ceil((Number(deadline || 0) - nowValue) / 1000));
}

export function formatCooldown(secondsValue) {
    const seconds = Math.max(0, Number(secondsValue) || 0);
    const minutesPart = Math.floor(seconds / 60);
    const secondsPart = String(seconds % 60).padStart(2, '0');
    return `${minutesPart}:${secondsPart}`;
}
